import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { ZDARZENIE_PREMIUM } from '../../api/apiFetch'
import { useAuth } from '../../context/AuthContext'
import { POMIAR_PLANOW_WLACZONY } from '../../config/plany'
import { zdarzenie } from '../../lib/pomiar'
import OknoPremium from './OknoPremium'

/**
 * Jedno okno „Przejdź na Premium” na cały serwis (FE-02).
 *
 * Otwierają je: `useOknoPremium().otworz(funkcja)` (kłódka, karta Premium) i odpowiedź 402 z backendu, którą
 * `api/apiFetch` ogłasza zdarzeniem `ZDARZENIE_PREMIUM`. Po 402 doczytujemy profil: skoro serwer odmówił, plan
 * w interfejsie jest nieaktualny (np. próba skończyła się w trakcie pracy) i kłódki mają się pojawić od razu.
 */

const OknoPremiumContext = createContext({ otworz: () => {} })

export const OknoPremiumProvider = ({ children }) => {
  const [okno, setOkno] = useState(null)
  const { odswiezProfil } = useAuth()

  const otworz = useCallback((funkcja = null) => {
    setOkno({ funkcja })
    if (POMIAR_PLANOW_WLACZONY) zdarzenie('okno_premium', funkcja || '')
  }, [])
  const zamknij = useCallback(() => setOkno(null), [])

  useEffect(() => {
    const zSerwera = (e) => {
      otworz(e.detail?.funkcja || null)
      if (odswiezProfil) odswiezProfil()
    }
    window.addEventListener(ZDARZENIE_PREMIUM, zSerwera)
    return () => window.removeEventListener(ZDARZENIE_PREMIUM, zSerwera)
  }, [otworz, odswiezProfil])

  const value = useMemo(() => ({ otworz }), [otworz])

  return (
    <OknoPremiumContext.Provider value={value}>
      {children}
      {okno && <OknoPremium funkcja={okno.funkcja} onZamknij={zamknij} />}
    </OknoPremiumContext.Provider>
  )
}

export const useOknoPremium = () => useContext(OknoPremiumContext)

export default OknoPremiumContext
